import classNames from 'classnames'
import css from './milestones.scss'

interface MilestonesProps {
  startYear: number
}

const Milestones = ({ startYear }: MilestonesProps) => (
  <div
    className={classNames(css.milestones, 'flex center col text-center mbxl')}
  >
    <p className="h3 text-bold man">If your baby is born in</p>
    <p className={classNames(css.startYear, 'text-bold man')}>{startYear}</p>
    <div className={classNames(css.milestone, css.first)}>
      <span className="text-bold">{startYear + 5}:</span> Starts Kindergarten
    </div>
    <div className={classNames(css.milestone, css.second)}>
      <span className="text-bold">{startYear + 18}:</span> Graduates Highschool
    </div>
    <div className={classNames(css.milestone, css.third)}>
      <span className="text-bold">{startYear + 21}:</span> Legal Drinking Age
    </div>
    <div className={classNames(css.milestone, css.fourth)}>
      <span className="text-bold">{startYear + 40}:</span> Turns 40
    </div>
    <div className={classNames(css.milestone, css.fifth)}>
      <span className="text-bold">{startYear + 62}:</span> Retirement
    </div>
  </div>
)

export default Milestones
